import initializeInfoBarIdsForItem from '../../infoBar/initializeInfoBarIdsForItem';
import Item from 'owa-service/lib/contract/Item';
import ItemViewState from '../../store/schema/ItemViewState';

export default function loadItemState(itemId: string, loadedItem: Item): ItemViewState {
    const itemViewState: ItemViewState = {
        itemId: itemId,
        isConversationItemPart: false,
        attachmentWell: null,
        isHeaderExpanded: false,
        isRecipientWellTruncated: false,
        infoBarIds: initializeInfoBarIdsForItem(), // this is a util
        loadingState: {
            isLoading: false,
            hasLoadFailed: false,
        },
    };
    return itemViewState;
}
